import { Component, OnInit } from '@angular/core';
import { ValidateService } from '../services/validate.service';
import { AuthService } from '../services/auth.service'
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

@Component({
  selector: 'login-cmp',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email : String;
  password : String;
  language : String;
  currentVersion : String = "4.1";

  constructor(
    private validateService:ValidateService,
    private flashMessage: FlashMessagesService,
    private authService: AuthService,
    private router: Router
  ) {

   }

  ngOnInit() {
      this.language = "A";
  }

    onLogin(){
    const luser = {
        email : this.email,
        password : this.password,
        version: this.currentVersion
    }
    if (this.language == "A") {
      this.flashMessage.show('Please select a language', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }

    if(!this.validateService.validateLogin(luser)){
      this.flashMessage.show('Please fill username and password', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }
    if(!this.validateService.validateEmail(luser.email)){
      this.flashMessage.show('Please enter valide email', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }

    this.authService.loginUser(luser).subscribe(data =>{
      if(data.error != null){
        this.flashMessage.show(data.message, { cssClass: 'alert-danger', timeout: 5000 });
      }else{
        this.flashMessage.show('Authenticate Success.!', { cssClass: 'alert-success', timeout: 5000 });
        this.authService.storeUserData(this.language, data.content.token, data.content.user);
        this.router.navigate(['/dashboard']);
      }
    });
  }

  signup(){
      this.router.navigate(['/signup']);
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts